<template>
  <footer class="app-footer">
    <div class="app-footer__inner">
      <!-- Identité -->
      <div class="app-footer__brand">
        <div class="app-footer__brand-icon">
          <VaIcon name="mso-science" size="16px" />
        </div>

        <div class="app-footer__brand-content">
          <span class="app-footer__brand-name">HemoCare SRL </span>

          <span class="app-footer__brand-separator">•</span>

          <span class="app-footer__brand-module"> Tableau de bord </span>
        </div>
      </div>

      <!-- Statut -->
      <div class="app-footer__status">
        <span class="app-footer__status-dot"></span>

        <span> Plateforme opérationnelle </span>
      </div>

      <!-- Copyright -->
      <div class="app-footer__copyright">
        <span> © {{ currentYear }} HemoCare SRL </span>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
const currentYear = new Date().getFullYear()
</script>

<style scoped>
/* ============================================================
   FOOTER
============================================================ */

.app-footer {
  margin-top: 1.5rem;

  border-top: 1px solid #e2e8f0;

  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);

  box-shadow: 0 -2px 8px rgba(15, 23, 42, 0.025);
}

/* ============================================================
   INNER
============================================================ */

.app-footer__inner {
  min-height: 58px;

  max-width: 100%;

  padding: 0.75rem 1.25rem;

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 1rem;
}

/* ============================================================
   BRAND
============================================================ */

.app-footer__brand {
  display: flex;
  align-items: center;
  gap: 0.65rem;

  min-width: 0;
}

.app-footer__brand-icon {
  width: 30px;
  height: 30px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;

  color: #2563eb;

  background: linear-gradient(135deg, #eff6ff, #eef2ff);

  border: 1px solid #dbeafe;
}

.app-footer__brand-content {
  display: flex;
  align-items: center;
  gap: 0.4rem;

  white-space: nowrap;
}

.app-footer__brand-name {
  font-size: 0.78rem;
  font-weight: 800;

  color: #0f172a;

  letter-spacing: -0.01em;
}

.app-footer__brand-separator {
  color: #cbd5e1;
  font-size: 0.75rem;
}

.app-footer__brand-module {
  font-size: 0.75rem;
  font-weight: 500;

  color: #64748b;
}

/* ============================================================
   STATUS
============================================================ */

.app-footer__status {
  display: flex;
  align-items: center;
  gap: 0.45rem;

  font-size: 0.7rem;
  font-weight: 600;

  color: #64748b;
}

.app-footer__status-dot {
  width: 7px;
  height: 7px;

  border-radius: 50%;

  background: #10b981;

  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.12);
}

/* ============================================================
   COPYRIGHT
============================================================ */

.app-footer__copyright {
  font-size: 0.7rem;
  font-weight: 500;

  color: #94a3b8;

  white-space: nowrap;
}

/* ============================================================
   RESPONSIVE
============================================================ */

@media (max-width: 768px) {
  .app-footer__inner {
    min-height: 52px;

    padding: 0.65rem 0.85rem;

    flex-wrap: wrap;

    justify-content: center;

    gap: 0.45rem 1rem;
  }

  .app-footer__brand {
    width: 100%;
    justify-content: center;
  }

  .app-footer__status {
    font-size: 0.68rem;
  }

  .app-footer__copyright {
    font-size: 0.68rem;
  }
}

@media (max-width: 480px) {
  .app-footer__brand-module,
  .app-footer__brand-separator {
    display: none;
  }

  .app-footer__inner {
    gap: 0.6rem;
  }
}
</style>
